import React from "react";
import './ProgressBarComponent.scss'

interface ProgressBarComponentProps {
    progress?: number
    animated?: boolean
    fixed?: boolean
    timeToComplete?: number
    height?: string,
    backgroundColor?: string
}

export const ProgressBarComponent: React.FC<ProgressBarComponentProps> =
    ({progress, timeToComplete, height, fixed, animated, backgroundColor}: ProgressBarComponentProps) => {

    return (
        <div style={{ height: `${height ? height : '4px'}` }} className={`width-full ${fixed ? 'progress-bar-container' : 'progress-bar-container-animated'} full-border-radius`}>
            {
                fixed ?
                    <div style={{ width: `${progress ? progress : 100}%`, height: `${height ? height : '4px'}` }} className={`progress-bar progress-bar-color full-border-radius`}></div>
                    :
                    ''
            }
            {
                animated ?
                    <div style={{animationDuration: `${timeToComplete ? timeToComplete : 1}s`, height: `${height ? height : '4px'}`, background: `${backgroundColor ?? ''}`}}
                         className={`progress-bar animation progress-bar-color full-border-radius`}></div>
                    :
                    ''
            }
        </div>
    )

}